export default "__VITE_ASSET__128ffd1f__"